import { useEffect, useState } from "react";

import L from "leaflet";
import "leaflet-kml";

import CloseSvg from "../Svg/CloseSvg";
import PlusSvg from "../Svg/PlusSvg";
import UndoSvg from '../Svg/UndoSvg';

import './WindyMap.scss';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'leaflet.markercluster';
import Map from '../Map/Map';

const WindyMap = ({ mapRef, highlightedRegion, setHighlightedRegion }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [mobileDetect, setMobileDetect] = useState(false);
  const [temperatureLayer, setTemperatureLayer] = useState(true);
  const [particleLayer, setParticleLayer] = useState(true);

  const handleButtonClick = () => setIsOpen((prev) => !prev);

  useEffect(() => {
    const handleResize = () => {
      setMobileDetect(window.innerWidth < 768);
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      <div id="windy">
        <Map
          temperatureLayer={temperatureLayer}
          particleLayer={particleLayer}
          mapRef={mapRef}
          highlightedRegion={highlightedRegion}
        />
      </div>
      <div className="layer-toggles">
        <div className="toggle-item">
          <label className="toggle-switch">
            <input type="checkbox" checked={particleLayer} onChange={() => setParticleLayer(!particleLayer)} />
            <span className="toggle-slider"></span>
          </label>
          <span className="toggle-label">Wind</span>
        </div>

        <div className="toggle-item">
          <label className="toggle-switch">
            <input type="checkbox" checked={temperatureLayer} onChange={() => setTemperatureLayer(!temperatureLayer)} />
            <span className="toggle-slider"></span>
          </label>
          <span className="toggle-label">Temperature</span>
        </div>
        {highlightedRegion && (
          <div className="toggle-item reset-btn" onClick={() => setHighlightedRegion(null)}>
            <UndoSvg />
            <span className="toggle-label">Reset region</span>
          </div>
        )}
      </div>
      <div id="aqi-legend" className={`aqi-legend-container ${isOpen ? '' : 'hidden'}`}>
        <span className="aqi-box aqi-good">Good</span>
        <span className="aqi-box aqi-moderate">Moderate</span>
        <span className="aqi-box aqi-sensitive">Unhealthy for sensitive groups</span>
        <span className="aqi-box aqi-unhealthy">Unhealthy</span>
        <span className="aqi-box aqi-very-unhealthy">Very unhealthy</span>
        <span className="aqi-box aqi-hazardous">Hazardous</span>
      </div>
      <div className="legend-button-container" onClick={handleButtonClick}>
        <div className="button-label">Legend</div>
        <div className="legend-button">{isOpen ? <CloseSvg /> : <PlusSvg />}</div>
      </div>
    </>
  );
};

export default WindyMap;
